import React from 'react';

/** ID is essential for this SVG for the component to be independent */
const EmergeLogoComponent: React.FC<{ id: string; width?: string; height?: string }> = (props) => (
  <svg
    id={props.id}
    key={props.id}
    width={props.width ?? '20'}
    height={props.height ?? '25'}
    viewBox="0 0 20 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <g id={props.id} key={props.id}>
      <path
        id={`Vector-${props.id}`}
        d="M6.30977 8.44645C6.98566 8.44645 7.66155 8.45402 8.33744 8.44645C9.30571 8.43699 9.93034 7.9884 10.2474 7.07607C10.4316 6.54799 10.5853 6.01043 10.7809 5.48803C11.0923 4.6552 11.7093 4.23689 12.594 4.23689C14.2477 4.23311 17.6309 4.23689 19.2846 4.23689C19.8864 4.23689 19.9985 4.12522 20.0003 3.54414C20.0003 2.58449 20.0003 1.62296 20.0003 0.663316C20.0003 0.0784454 19.9206 0.00273402 19.3188 0.000841238C18.1113 0.000841238 15.1723 -0.00105155 13.9648 0.000841238C13.0022 0.00273402 12.3605 0.466466 12.0605 1.375C11.9086 1.83684 11.7606 2.30058 11.6068 2.76241C11.2783 3.74098 10.6556 4.20472 9.61518 4.2104C7.81913 4.21986 2.57338 4.21229 0.775436 4.21418C0.0729657 4.21418 0.00651587 4.28043 0.0046173 4.97319C0.0046173 5.90444 0.000820166 6.83569 0.0046173 7.76694C0.00841444 8.31017 0.150807 8.44645 0.703291 8.44834C1.42285 8.45213 5.58831 8.44834 6.30787 8.44834L6.30977 8.44645Z"
        fill={`url(#paint0_linear_13731_140140-${props.id})`}
      />
      <path
        id={`Vector2-${props.id}`}
        d="M4.30165 12.5368C3.52704 12.5368 4.46683 12.533 3.69032 12.5368C3.23846 12.5387 3.14732 12.6295 3.14543 13.0762C3.14163 14.0226 3.14163 14.969 3.14543 15.9154C3.14543 16.3299 3.28022 16.4681 3.69601 16.47C4.85983 16.4757 5.87177 16.4851 7.03369 16.47C7.89185 16.4586 8.4918 15.993 8.76139 15.1734C8.91518 14.7059 9.05947 14.2346 9.22085 13.769C9.49234 12.9778 10.0809 12.5576 10.9125 12.5557C12.6383 12.5538 14.3622 12.5557 16.088 12.5557C16.6575 12.5557 16.7639 12.4497 16.7677 11.8743C16.7715 10.9942 16.7715 10.114 16.7677 9.23578C16.7658 8.71526 16.6727 8.62063 16.1639 8.61873C14.814 8.61684 13.4622 8.61495 12.1124 8.61873C11.3396 8.62063 10.753 9.02947 10.491 9.75251C10.3277 10.203 10.1872 10.661 10.041 11.1172C9.72966 12.0844 9.13921 12.5217 8.11018 12.5368C8.09689 12.5368 8.0836 12.5368 8.07031 12.5368C7.33557 12.5368 5.0345 12.5368 4.29976 12.5368H4.30165Z"
        fill={`url(#paint1_linear_13731_140140-${props.id})`}
      />
      <path
        id={`Vector3-${props.id}`}
        d="M3.20763 20.7568C2.37416 20.7568 1.42108 20.7531 0.587607 20.7568C0.101573 20.7587 0.00284785 20.8591 0.00284785 21.3398C-0.000949284 22.3581 -0.000949284 23.3746 0.00284785 24.3929C0.00284785 24.8377 0.149038 24.9891 0.595201 24.991C1.84636 24.9967 3.21523 25.008 4.46638 24.991C5.38909 24.9796 6.0346 24.4762 6.32508 23.5941C6.49026 23.0906 6.64594 22.5853 6.81871 22.0837C7.11109 21.2338 7.74331 20.7814 8.63754 20.7796C10.4924 20.7777 17.3975 20.7796 19.2505 20.7796C19.8619 20.7796 19.9777 20.6641 19.9815 20.047C19.9853 19.1007 19.9853 18.1562 19.9815 17.2098C19.9796 16.6495 19.879 16.5473 19.3341 16.5473C17.8817 16.5454 11.3791 16.5435 9.92856 16.5473C9.09699 16.5492 8.46667 16.9883 8.18568 17.7662C8.01101 18.2508 7.85912 18.7429 7.70154 19.2331C7.36739 20.2742 6.73137 20.7417 5.62641 20.7587C5.61122 20.7587 5.59793 20.7587 5.58274 20.7587C4.79294 20.7587 4.00123 20.7587 3.21143 20.7587L3.20763 20.7568Z"
        fill={`url(#paint2_linear_13731_140140-${props.id})`}
      />
    </g>
    <defs>
      <linearGradient
        id={`paint0_linear_13731_140140-${props.id}`}
        x1="7.85674"
        y1="6.42342"
        x2="12.0552"
        y2="2.02033"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#00B9CA" />
        <stop offset="1" stopColor="#11E6C0" />
      </linearGradient>
      <linearGradient
        id={`paint1_linear_13731_140140-${props.id}`}
        x1="7.67782"
        y1="15.2658"
        x2="10.7088"
        y2="11.5513"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#00B9CA" />
        <stop offset="1" stopColor="#11E6C0" />
      </linearGradient>
      <linearGradient
        id={`paint2_linear_13731_140140-${props.id}`}
        x1="7.45456"
        y1="24.3762"
        x2="10.0957"
        y2="20.5244"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#00B9CA" />
        <stop offset="1" stopColor="#11E6C0" />
      </linearGradient>
    </defs>
  </svg>
);

export default EmergeLogoComponent;
